import { Module, VuexModule, Action } from 'vuex-module-decorators';
import axios from 'axios';
import { toError, assertOk } from '@/services/normalize';
import { BASE_URL, CAMPAIGN_LIST, CAMPAIGN_ADD, M_POST, M_GET } from '@/utils/api';
import type { ExtAxiosConfig } from '@/middleware/axios-ui';

@Module({ name: 'campaign', namespaced: true })
export default class Campaign extends VuexModule {
  @Action({ rawError: true })
  async FetchCampaignList(payload: any) {
    console.log(BASE_URL + CAMPAIGN_LIST);

    try {
      const { criteria, __successToast } = payload || {};

      const { data } = await axios({
        url: BASE_URL + CAMPAIGN_LIST,
        data: criteria,
        method: M_GET,
        __successToast
      } as ExtAxiosConfig);

      assertOk(data, 'Fetch campaign list failed');
      return data;
    } catch (err) {
      throw toError(err, 'Fetch campaign list failed');
    }
  }

  @Action({ rawError: true })
  async AddCampaign(payload: any) {
    try {
      const { criteria, __successToast } = payload || {};

      const { data } = await axios({
        url: BASE_URL + CAMPAIGN_ADD,
        data: criteria,
        method: M_POST,
        __successToast
      } as ExtAxiosConfig);

      assertOk(data, 'Add campaign failed');
      return data;
    } catch (err) {
      throw toError(err, 'Add campaign failed');
    }
  }
}
